export default __webpack_public_path__ + "static/media/team_3.dc473f69.jpg";